export const responsive = [
    {
        width: 0,
        item: 1
    }, {
        width: 768,
        item: 2
    }, {
        width: 1024,
        item: 3
    }, {
        width: 1280,
        item: 4
    },
]